import {
  HistoryDetail,
  PostalAddressOption,
  TermsAndConditions,
} from 'scenes/common/flows/policyDetails/types';
import {
  LocalityAddress,
  PostalAddress,
  PolicyHolder,
  YesNoAnswer,
  YesNoDontKnowAnswer,
  PaymentFrequency,
} from 'scenes/common/types';

export enum HomePolicySubSection {
  ProperyInGoodCondition = 'Property in good condition',
  PropertyUnderRenovation = 'Property under renovation',
  ReplumbedOrRewired = 'Replumbed or rewired',
  HeritageListed = 'Heritage listed',
  PropertyUnoccupied = 'Property unoccupied',
  PropertyOver5Acres = 'Property over 5 acres',
  PropertyUnrelatedPeople = 'Property unrelated people',
  PersonalPolicyContact = 'Personal policy contact',
  BusinessPolicyContact = 'Business policy contact',
  ContactPhoneNumber = 'Contact phone number',
  ContactEmailAddress = 'Contact email address',
  // eslint-disable-next-line no-shadow
  PostalAddress = 'Postal address',
  BusinessNameAndAbn = 'Business name and ABN',
  AdditionalPolicyHolders = 'Additional policy holders',
  PolicyHolderDeclaration = 'Policy holder declaration',
  Mortgage = 'Mortgage',
  CashKeptAtHome = 'Cash kept at home',
  StockKeptAtHome = 'Stock kept at home',
  HazardGoodsKeptAtHome = 'Hazard goods kept at home',
  NumberOfVisits = 'Number of visits',
  BusinessRegisteredForGst = 'Business registered for GST',
}

export interface PolicyDetailsData {
  propertyInGoodCondition: YesNoAnswer;
  heritageListed: YesNoAnswer;
  rewiredOrReplumbed: YesNoDontKnowAnswer;
  propertyUnoccupied: YesNoAnswer;
  propertyRenovationCurrent: YesNoAnswer;
  propertyRenovationFuture?: YesNoAnswer;
  over5Acres: YesNoAnswer;
  propertyOccupancy: YesNoAnswer;
  cashKeptAtHome: YesNoAnswer;
  stockKeptAtHome: YesNoAnswer;
  hazardGoodsKeptAtHome: YesNoAnswer;
  numberOfVisits: number;
  businessRegisteredForGst: YesNoAnswer;
  historyDetails: HistoryDetail[];
  mortgageProvider: string;
  mortgageProviderOther: string;
  businessName: string;
  abn: string;
  businessContactFirstName: string;
  businessContactLastName: string;
  personalContactFirstName: string;
  personalContactLastName: string;
  addAdditionalPolicyHolder: YesNoAnswer;
  additionalPolicyHolders: PolicyHolder[];
  additionalPolicyHolder?: PolicyHolder;
  contactPhoneNumber: string;
  contactEmailAddress: string;
  postalAddressOption: PostalAddressOption;
  isPostalAddressDifferentManual?: boolean;
  lockedBoxAddress: LocalityAddress;
  postalAddress: PostalAddress;
  termsAndCondition: TermsAndConditions;
  preselectedPaymentFrequency: PaymentFrequency;
}

export const NUMBER_OF_VISITS_OPTIONS = [
  { label: 'None', value: 0 },
  { label: '1 to 4', value: 1 },
  { label: '5 or more', value: 5 },
];
